<template>
    <div>
        <div>
            <SkeletonTheme color="#EEEEEE" highlight="#FFFFFF">
            <div class="item mt-3">
                <div>
                    <Skeleton width="50px" class="mr-3 ml-3"  style="float-left"></Skeleton>
                    <Skeleton width="50px" class="mr-3" style="float-left"></Skeleton>
                    <Skeleton width="50px" class="mr-3" style="float-left"></Skeleton>
                    <Skeleton width="50px" style="float-left"></Skeleton>
                </div>
            </div>
            </SkeletonTheme>
            <SkeletonTheme color="#EEEEEE" highlight="#FFFFFF">
                <div class="ml-3 mr-3 mt-2">
                    <Skeleton :count="3"></Skeleton>
                </div>
            </SkeletonTheme>
            <SkeletonTheme color="#EEEEEE" highlight="#FFFFFF">
            <div class="item mt-2">
                <div>
                    <Skeleton width="50px" height="15px" class="mr-3 ml-3"  style="float-left"></Skeleton>
                    <Skeleton width="50px" height="15px" class="mr-3" style="float-left"></Skeleton>
                    <Skeleton width="50px" height="15px" class="mr-3" style="float-left"></Skeleton>
                </div>
            </div>
            </SkeletonTheme>
        </div>
    </div>
</template>

<script>
import { SkeletonTheme, Skeleton } from 'vue-loading-skeleton';

export default {
    components: {
        SkeletonTheme,
        Skeleton,
    },
    props: ['payload'],
    data() {
        return {

        }
    },
}
</script>
